const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-46f1f103-bac7-47c6-abfc-d90b930cf11c {\n        stroke-width: 2px;\n      }\n\n      .uuid-46f1f103-bac7-47c6-abfc-d90b930cf11c, .uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .uuid-eb6a7bad-37fa-4fdb-9f1c-63fbbc3e7fb2 {\n        fill: #5e3524;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-f60588b0-c481-4a94-a8a8-c9898e3816da",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-eb6a7bad-37fa-4fdb-9f1c-63fbbc3e7fb2",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-572c9e38-14b3-411d-bcc9-9ebe138bf4f7",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-46f1f103-bac7-47c6-abfc-d90b930cf11c",
  d: "M36.65,11.5l-2.4,2.4c-1.05,1.05-2.19,1.41-2.6,1.53-.05.14-.12.26-.23.37l-9.8,9.8c.09.16.22.27.39.35.4.19,1.05.17,1.86-.03.65-.18,1.18-.42,1.19-.42.33-.15.71.1.69.46-.06,1.23-.9,2.19-1.93,2.85-.36.23-.78.41-1.24.52-.6.14-1.48.82-1.75,1.94-.19.81-.52,1.61-.97,2.38-1.5,2.59-4.93,3.26-7.28,1.41-.72-.56-.98-.9-1.49-1.39-3.91-3.79-2.65-6.43-1.56-7.67.53-.6,1.22-1.08,1.98-1.39,1.73-.69,3.03-1.4,3.87-2.1.68-.56.84-.97.88-1.11.1-.34.21-.64.35-.92.91-1.78,1.94-2.83,3.08-3.12.99-.25,1.68.19,1.75.23.23.16.28.5.1.72-.58.69-1.75,2.39-1.54,3.26.02.09.06.19.16.29l8.66-8.66c.16-.16.36-.26.56-.28.17-.51.56-1.49,1.48-2.41l2.39-2.4c.19-.19.5-.19.69,0l2.7,2.7c.19.19.19.49,0,.69Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 29.39,
  y1: 12.92,
  x2: 31.65,
  y2: 15.42
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 27.42,
  y1: 14.72,
  x2: 29.79,
  y2: 17.35
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 25.49,
  y1: 16.57,
  x2: 27.87,
  y2: 19.21
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 23.57,
  y1: 18.5,
  x2: 25.95,
  y2: 21.13
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 21.62,
  y1: 20.44,
  x2: 24,
  y2: 23.08
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 21.71,
  y1: 21.02,
  x2: 15.06,
  y2: 27.64
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x1: 23.47,
  y1: 22.94,
  x2: 16.94,
  y2: 29.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "uuid-5c12e72b-bf7e-4a5a-92d2-9fec8e77fb4d",
  x: 12.67,
  y: 28.18,
  width: 4.72,
  height: 2.71,
  transform: "translate(25.29 -1.98) rotate(45)"
}));
function SvgRepozeIconCategoryInstruments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryInstruments);
export default __webpack_public_path__ + "static/media/repoze_icon_category-instruments.88448b7b125ea58c570b9efbac8687ca.svg";
export { ForwardRef as ReactComponent };